import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import Grid from '@mui/material/Grid';
import './manage-employer-file-list.css';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
// import Popover from '@mui/material/Popover';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
// import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import http from '../../services/http-service'
import { ToastContainer, toast } from 'react-toastify';
import Pagination from '@mui/material/Pagination';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Moment from 'moment';
import Stack from '@mui/material/Stack';
import debounce from 'lodash.debounce'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';


const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

export default function ManageEmployerFilesList(props) {
    // const [anchorEl, setAnchorEl] = React.useState(null);
    // const handleClick = (event) => {
    //     setAnchorEl(event.currentTarget);
    // };

    // const handleClose = () => {
    //     setAnchorEl(null);
    // };

    // const open = Boolean(anchorEl);
    // const id = open ? 'simple-popover' : undefined;

    const history = useHistory();
    const [count, setCount] = useState(0);
    const [searchItem, setSearchItem] = useState('');
    const [openSpinner, setOpenSpinner] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(parseInt(props.match.params.page))

    const handleSpinnerClose = () => {
        setOpenSpinner(false);
    };
    const handleSpinnerToggle = () => {
        setOpenSpinner(!openSpinner);
    };

    const uploadEmployer = () => {
        history.push('/upload-employer')
    }

    const handleChangePage = (event, page) => {
        history.push('/manage-employer-files-list/' + page)
        fetchEmployerFileList(page, searchItem)
    }

    const handleSearch = debounce((value) => {
        setSearchItem(value)
        setCurrentPage(1)
        history.push('/manage-employer-files-list/' + 1)
        fetchEmployerFileList(1, value)
    }, 1000)

    const fetchEmployerFileList = (page, search) => {
        if (page)
            setCurrentPage(parseInt(page))
        else
            setCurrentPage(1)

        let params = {
            page: page,
            search: search
        }
        handleSpinnerToggle()
        http('employer/csv_uploaded_employer_list/', 'GET', '', params)
            .then(res => {
                if (res.status) {
                    setCount(0)
                    setCount(Math.ceil(res.data.count / res.data.page_size))
                    setTableData(res.data.results)
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId21"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                })
    }

    const downloadFailedFiles = (data) => {
        if(data.row_failed === 0)
            return
        let params = {
            type: 'employers',
            record_id: data.id
        }
        handleSpinnerToggle();
        http('employer/csv_failed_report_view/', 'GET', '', params)
            .then(res => {
                if (res.status) {
                    window.location.href = res.data.data
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId2"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                })
    }

    useEffect(() => {
        fetchEmployerFileList(currentPage, searchItem);
        // eslint-disable-next-line
    }, []);
    return (
        <div className="mainAppDiv">

            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openSpinner}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Grid item container xs={12} md={12} sm={12} lg={12} xl={12} className='commonPageDivGrid'>
                <PriorityHighIcon className='PriorityHighIcon' />
                <div className='employeeFileUp'>Employer file upload: you can view details of files uploaded to Wagefit, download previously uploaded files and upload new employer files</div>
            </Grid>

            <div className='upEmpFiles'>
                <Grid container className='commonPageDivGrid upEmpFilesGrid'>
                    <Grid item lg={5} className='upGrid5Div'>
                        <Typography variant="caption" display="block" gutterBottom className='upGrid5DivFirst'>
                            Employer Files
                            <Typography variant="caption" display="block" gutterBottom className='gridTextEmp'>
                                uploaded and new
                            </Typography>
                        </Typography>
                    </Grid>

                    <Grid item lg={4} className='upsearchGrid'>
                        <Search className='upseacrchDiv'>
                            <SearchIconWrapper>
                                <SearchIcon />
                            </SearchIconWrapper>
                            <StyledInputBase onChange={(e) => {
                                handleSearch(e.target.value)
                            }}
                                placeholder="Search…"
                                inputProps={{ 'aria-label': 'search' }}
                            />
                        </Search>
                    </Grid>



                    <Grid item lg={3} className='upBtnGrid'>
                        <div>
                            <label htmlFor="myInput" className='upBtnGridBtn cursorPointer'><UploadOutlinedIcon />Upload Employer </label>
                            <input
                                id="myInput"
                                style={{ display: 'none' }}
                                type={"button"}
                                onClick={uploadEmployer}
                            />
                        </div>
                    </Grid>

                    {/* <Grid item lg={0.5} className='uppopOverGrid'>
                        <PendingOutlinedIcon aria-describedby={id} variant="contained" onClick={handleClick} className='PendingOutlinedIconClass' />
                        <Popover className='uppopOver'
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{

                            }}
                        >
                            <Typography sx={{ p: 2 }}>The content of the Popover.</Typography>
                        </Popover>

                    </Grid> */}
                </Grid>

                {
                    tableData.length > 0 ? (
                        <div className='customTable'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>File Name 
                                            <span className='filterIconGrid'>
                                                <ArrowDownwardIcon className='ArrowDownwardIcon'></ArrowDownwardIcon>     
                                                <ArrowUpwardIcon className='ArrowUpwardIcon'></ArrowUpwardIcon> 
                                            </span>                                 
                                        </th>
                                        <th>File Status 
                                            <span className='filterIconGrid'>
                                                <ArrowDownwardIcon className='ArrowDownwardIcon'></ArrowDownwardIcon>     
                                                <ArrowUpwardIcon className='ArrowUpwardIcon'></ArrowUpwardIcon> 
                                            </span>    
                                        </th>
                                        <th>Row Count 
                                        <span className='filterIconGrid'>
                                                <ArrowDownwardIcon className='ArrowDownwardIcon'></ArrowDownwardIcon>     
                                                <ArrowUpwardIcon className='ArrowUpwardIcon'></ArrowUpwardIcon> 
                                            </span>    
                                        </th>
                                        <th>Row Count(Success) 
                                        <span className='filterIconGrid'>
                                                <ArrowDownwardIcon className='ArrowDownwardIcon'></ArrowDownwardIcon>     
                                                <ArrowUpwardIcon className='ArrowUpwardIcon'></ArrowUpwardIcon> 
                                            </span>    
                                        </th>
                                        <th>Row Count(Failure) 
                                        <span className='filterIconGrid'>
                                                <ArrowDownwardIcon className='ArrowDownwardIcon'></ArrowDownwardIcon>     
                                                <ArrowUpwardIcon className='ArrowUpwardIcon'></ArrowUpwardIcon> 
                                            </span>    
                                        </th>
                                        <th>Uploaded Date 
                                        <span className='filterIconGrid'>
                                                <ArrowDownwardIcon className='ArrowDownwardIcon'></ArrowDownwardIcon>     
                                                <ArrowUpwardIcon className='ArrowUpwardIcon'></ArrowUpwardIcon> 
                                            </span>    
                                        </th>
                                        <th>Uploaded By 
                                        <span className='filterIconGrid'>
                                                <ArrowDownwardIcon className='ArrowDownwardIcon'></ArrowDownwardIcon>     
                                                <ArrowUpwardIcon className='ArrowUpwardIcon'></ArrowUpwardIcon> 
                                            </span>    
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {tableData.map((data, index) => (
                                        <tr key={index}>
                                            <td key={'csv_name' + index} >{data.csv_name}</td>
                                            <td key={'file_status' + index}>{data.file_status}</td>
                                            <td key={'row_count' + index}>{data.row_count}</td>
                                            <td key={'row_success' + index}>{data.row_success}</td>
                                            <td key={'row_failed' + index}><p className='linkStyle' onClick={() => downloadFailedFiles(data)}>{data.row_failed}</p></td>
                                            <td key={'created_on' + index}>{Moment(data.created_on).format('lll')}</td>
                                            <td key={'uploaded_by' + index}>{data.uploaded_by}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Stack spacing={2} className="employeePagination">
                                <Pagination count={count} color="primary" page={currentPage} onChange={handleChangePage}
                                />
                            </Stack>
                        </div>
                    ) : (
                        <div className='recordNotFoundDiv'>
                            <h2>Records Not Found</h2>
                        </div >
                    )
                }
            </div>
        </div>
    )

}
// export default UploadEmployee;